module.exports = __webpack_public_path__ + "img/bodyParts.e335f317.svg";